import BaseEntity from '../BaseEntity.model';
import { Facility } from '../Regions/Facility.model';

export default interface IHospitalizationModel extends BaseEntity {
    MemberId: string;
    Facility: Facility | null;
    StartDate: Date;
    EndDate: Date;
    ReasonForHospitalization: string;
    AdditionalDetails: string;
    IsDeleted: boolean;
}

export class HospitalizationModel implements IHospitalizationModel {
    Id: string;
    MemberId: string;
    Facility: Facility | null;
    StartDate: Date;
    EndDate: Date;
    ReasonForHospitalization: string;
    AdditionalDetails: string;
    IsDeleted: boolean;

    constructor() {
        this.Id = '';
        this.MemberId = '';
    }
}
